/**
 * This holds the resolutions for each type of Content. It's not a problem to repeat it :)
 *
 * @returns {object}
 */
const imageResolutions = {
  THUMBNAIL: '300x300', // default size
  STYLE_THUMBNAIL: '300x300',
  STYLE_FEEDBACK: '300x300',
  STYLE_SHARED: '300x300',
  STYLE: '600x600',
  STYLE_SINGLE: '600x600',
  STYLE_FULL: '1200x1200',
  DETAIL_THUMBNAIL: '300x300',
  DETAIL: '600x600',
  DETAIL_FULL: '1200x1200',
  RENDER_PREVIEW: '600x600',
  LABEL_THUMBNAIL: '300x300',
  ZOOM: '5000x5000'
}

/**
 * Different filters for each resolution
 *
 * @returns {object}
 */
const imageFilters = {
  '300x300': ['upscale()', 'sharpen(0.6,0.4,true)'],
  '600x600': ['upscale()', 'sharpen(1.0,0.5,true)'],
  '1200x1200': ['upscale()', 'sharpen(1.2,0.6,false)']
}

export { imageResolutions, imageFilters }
